import { ModalsServicesProvider } from './ModalsServicesProvider'

export * from './ModalsServicesProvider'
export default ModalsServicesProvider
